export default __webpack_public_path__ + "static/media/filter-empty.e1d29bd3.svg";